require("@/bootstrap");
require("../plugins/modernizr-custom");

const { Modal } = require('flowbite');
window.Modal = Modal;

const PopupManager = require('@/utils/PopupManager');

const loading = document.querySelector('#loading');
if (loading) {
    loading.style.opacity = '1';
    loading.style.transition = 'opacity 0.4s ease';
    loading.style.opacity = '0';
    setTimeout(() => {
        loading.style.display = 'none';
    }, 400);
}

document.addEventListener('DOMContentLoaded', function() {

    const abreMenu = document.getElementById("abre-menu");
    const cierraMenu = document.getElementById("cerrar-menu");
    const menu = document.getElementById("menu");

    if (abreMenu && menu) {
        abreMenu.addEventListener("click", function(e) {
            menu.classList.toggle("visible");
        });
    }

    if (cierraMenu && menu) {
        cierraMenu.addEventListener("click", function(e) {
            menu.classList.remove("visible");
        });
    }

    const btnUp = document.querySelector('.up');

    if (btnUp) {
        btnUp.addEventListener('click', function(e) {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });

        window.addEventListener('scroll', function() {
            if (window.scrollY > 300) {
                btnUp.style.opacity = "1";
                btnUp.style.visibility = "visible";
            } else {
                btnUp.style.opacity = "0";
                btnUp.style.visibility = "hidden";
            }
        });
    }

    // Scroll to section
    const scrollToElements = document.querySelectorAll('.scroll-to');
    scrollToElements.forEach(element => {
        element.addEventListener('click', function(e) {
            e.preventDefault();

            let targetId = '';
            if (this.dataset.scroll_to) {
                targetId = this.dataset.scroll_to;
            } else {
                targetId = this.getAttribute('href');
            }

            const targetElement = document.querySelector(targetId);
            const altoCabecera = 80;

            if (targetElement) {
                const targetPosition = targetElement.offsetTop - altoCabecera;
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }

            return false;
        });
    });

    window.addEventListener('scroll', function() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const header = document.querySelector('header');
        const body = document.body;

        if (scrollTop > 5) {
            header?.classList.add('scroll');
            body.classList.add('scroll');
        } else {
            header?.classList.remove('scroll');
            body.classList.remove('scroll');
        }
    });

    function isEmptySelect(select) {
        const parentFloating = select.closest('.form-floating');

        if (select.value === '') {
            parentFloating?.classList.add('empty');
        } else {
            parentFloating?.classList.remove('empty');
        }
    }

    const formBuscador = document.querySelector('#formulario-buscador');
    if (formBuscador) {
        const selects = formBuscador.querySelectorAll('select');

        selects.forEach(select => {
            select.addEventListener('change', function() {
                isEmptySelect(this);
            });

            isEmptySelect(select);
        });
    }

    const formularioBuscador = document.querySelector('.formulario-buscador');
    if (formularioBuscador) {
        formularioBuscador.addEventListener('submit', function(e) {
            e.preventDefault();

            let url = this.getAttribute('action');
            const ciudad = this.querySelector('select[name=ciudad]').value;
            const tipo = this.querySelector('select[name=tipologia]').value;

            url = `${url}/${ciudad}/${tipo}/regiones-todas`;
            console.log(url);
            window.location.href = url;
        });
    }

    // Modal Banco Estado
    const modalBancoEstado = document.querySelector('#modal-banco-estado');
    const closeModalBancoEstado = document.querySelector('#close-modal-banco-estado');

    if (modalBancoEstado) {
        modalBancoEstado.style.display = 'block';
    }

    if (closeModalBancoEstado) {
        closeModalBancoEstado.addEventListener('click', function() {
            modalBancoEstado.style.display = 'none';
        });
    }

    // Modal Promocional
    const modalPromoLink = document.querySelector('#modal-promocional-link');
    const modalPromociones = document.querySelector('#modal-promociones');

    if (modalPromoLink) {
        modalPromoLink.addEventListener('click', function() {
            if (modalPromociones) {
                modalPromociones.style.display = 'none';
            }
        });
    }
    const popupManager = new PopupManager();
    window.popupManager = popupManager;

});
